module.exports = __webpack_public_path__ + "static/media/tarjeta-cd.4ffa51f7.svg";